import api from "./config"; // Importamos la configuración de axios
import axios from "axios"; // 👈 asegúrate que esté al inicio del archivo
import { API_URL } from "./config"; // si no está, añádelo también arriba


// 🔹 Obtener todas las recetas de una historia clínica
export const obtenerRecetasPorHistoria = async (historiaClinicaId) => {
  try {
    const response = await api.get(`/recetas/${historiaClinicaId}`);
    return response.data.recetas || [];
  } catch (error) {
    console.error("Error obteniendo recetas:", error);
    return [];
  }
};
export const obtenerRecetasPorPaciente = async (pacienteId) => {
  try {
    const response = await api.get(`/recetas/por_paciente/?paciente_id=${pacienteId}`);
    return response.data || [];
  } catch (error) {
    console.error("Error obteniendo recetas por paciente:", error);
    return [];
  }
};

export const obtenerTodasLasRecetas = async () => {
  try {
    const response = await api.get("/recetas/");
    return response.data || [];
  } catch (error) {
    console.error("Error obteniendo todas las recetas:", error);
    return [];
  }
};


// 🔹 Obtener una receta específica por ID dentro de una historia clínica
export const obtenerRecetaPorId = async (historiaClinicaId, recetaId) => {
  try {
    const historia = await api.get(`/recetas/${historiaClinicaId}`);
    return historia.data.recetas.find((receta) => receta.id === recetaId);
  } catch (error) {
    console.error("Error obteniendo receta:", error);
    return null;
  }
};

// 🔹 Crear una nueva receta (independiente o ligada a una consulta)
export const crearReceta = async (nuevaReceta) => {
  try {
    const response = await api.post("/recetas/", nuevaReceta);
    return response.data;
  } catch (error) {
    console.error("Error creando receta:", error.response?.data || error);
    return null;
  }
};


// toda esta parte es para la configuracion de la receta
export const obtenerConfiguracionReceta = async () => {
  try {
    const response = await api.get("/configuracion-receta/");
  
    
    if (response.data) {
      // Si hay una clave "0" que contiene la configuración real (caso actual)
      if (response.data["0"] && response.data["0"].configuracion) {
       
        return response.data["0"];
      }
      // Si el backend devuelve {configuracion: {...}}
      else if (response.data.configuracion) {
        return response.data;
      } 
      // Si el backend devuelve directamente el objeto de configuración
      else if (typeof response.data === 'object') {
        // Filtrar solo las propiedades que son parte de la configuración real (no metadatos)
        const configProps = Object.keys(response.data).filter(key => 
          !["id", "medico", "creado_en", "actualizado_en"].includes(key)
        );
        
        // Si hay muchas propiedades, es probable que sea la configuración directa
        if (configProps.length > 10) {
          return {
            id: response.data.id || null,
            configuracion: response.data
          };
        }
      }
    }
    
   
    return null;
  } catch (error) {
    console.error("Error obteniendo configuración de receta:", error);
    return null;
  }
};
export const guardarConfiguracionReceta = async (configuracion) => {
  try {
    // Aseguramos que configuracion sea un objeto limpio y serializable
    const configLimpia = JSON.parse(JSON.stringify(configuracion));
    
  
    
    // Preparar datos para enviar en el formato correcto
    const datosParaEnviar = { configuracion: configLimpia };
    
    // Obtener configuración actual para decidir si crear o actualizar
    const configActual = await obtenerConfiguracionReceta();
    let response;
    
    if (configActual && configActual.id) {
     
      response = await api.patch(
        `/configuracion-receta/${configActual.id}/`, 
        datosParaEnviar
      );
    } else {
    
      response = await api.post(
        `/configuracion-receta/`, 
        datosParaEnviar
      );
    }
    
   
    return response.data;
  } catch (error) {
    console.error("Error guardando configuración de receta:", error);
    if (error.response) {
      console.error("Detalles del error:", error.response.status, error.response.data);
    }
    throw error;
  }
};

export const subirImagenConfiguracion = async (formData) => {
  try {
    const response = await api.post(
      "/upload-imagen-configuracion/", // esta es la url correcta de tu backend
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error subiendo imagen:", error);
    throw error;
  }
};

export const eliminarImagenConfiguracion = async (data) => {
  try {
    const response = await api.delete("/eliminar-imagen-configuracion/", { data }); // así se manda data en DELETE
    return response.data;
  } catch (error) {
    console.error("Error eliminando imagen:", error);
    throw error;
  }
};

// 2) ON (con firma): envía multipart (pdf + cer + key + password)
export const crearRecetaCrearYFirmarFirmada = async ({
  camposReceta,   // objeto con los campos normales de receta
  pdf,            // File/Blob del preview PDF
  cer,            // File .cer (DER)
  key,            // File .key (DER)
  password,       // string
}) => {
  const fd = new FormData();
  // Campos de receta
  // Campos de receta
  const meds = Array.isArray(camposReceta?.medicamentos) ? camposReceta.medicamentos : [];
  const medicamentosNormalizados = meds.map(m => ({
    nombre: m?.nombre || "",
    indicaciones: m?.indicaciones || "",
    vademecum_id: m?.vademecum_id ?? null,
  }));

  Object.entries(camposReceta || {}).forEach(([k, v]) => {
    if (k === "medicamentos") {
      // Mandar todo el arreglo como JSON, igual que en el flujo normal
      fd.append("medicamentos", JSON.stringify(medicamentosNormalizados));
      } else if (k === "signos_vitales_snapshot" && v !== undefined && v !== null) {
    fd.append("signos_vitales_snapshot", JSON.stringify(v));
    } else if (v !== undefined && v !== null) {
      fd.append(k, v);
    }
  });
  // Adjuntos de firma (claves EXACTAS que espera el backend)
  fd.append("pdf", pdf);
  fd.append("cer", cer);
  fd.append("key", key);
  fd.append("password", password);

  const res = await api.post("/recetas/crear_y_firmar/", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};


// === FUNCIONES PÚBLICAS (sin autenticación, AllowAny) ===

// Verificación pública (AllowAny)
export const verificarRecetaPublica = async (id) => {
  const res = await axios.get(`${API_URL}recetas/${id}/verificar/`);
  return res.data;
};

// Registrar dispensación (AllowAny)
export const registrarDispensacion = async (recetaId, payload) => {
  const res = await axios.post(`${API_URL}recetas/${recetaId}/dispensar/`, payload);
  return res.data;
};

//Log export
export const auditarRecetaExportada = async (recetaId) => {
  try {
    const response = await api.post("/auditoria/recetas/exportada/", {
      receta_id: recetaId,
      tipo_export: "pdf",
    });
    return response.data;
  } catch (error) {
    console.error("Error guardando evento de exportación de receta:", error.response?.data || error);
    return null;
  }
};


// 🔹 Resumen ligero para dashboard (solo id, fecha, diagnostico, es_firmada, nombrePaciente)
export const obtenerResumenRecetas = async () => {
  try {
    const response = await api.get("/recetas/resumen/");
    return response.data || [];
  } catch (error) {
    console.error("Error obteniendo resumen de recetas:", error);
    return [];
  }
};

export const obtenerRecetaPorIdDirecto = async (id) => {
  try {
    const response = await api.get(`/recetas/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo receta:", error);
    return null;
  }
};